export function sprint1ParseInt(
  valueToParse: string,
  base: number = 10
): number | undefined {
  const parsed = parseInt(valueToParse, base);
  if (isNaN(parsed)) {
    return undefined;
  }
  return parsed;
}
